import { render, staticRenderFns } from "./rmHuis.vue?vue&type=template&id=8ec32e26"
import script from "./rmHuis.vue?vue&type=script&lang=js"
export * from "./rmHuis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports